export var TAXONOMIC_LEVELS;
(function (TAXONOMIC_LEVELS) {
    TAXONOMIC_LEVELS["GENUS"] = "genus";
    TAXONOMIC_LEVELS["FAMILY"] = "family";
    TAXONOMIC_LEVELS["ORDER"] = "order";
    TAXONOMIC_LEVELS["SUPERORDER"] = "superorder";
    TAXONOMIC_LEVELS["SUBDIVISION"] = "subdivision";
})(TAXONOMIC_LEVELS || (TAXONOMIC_LEVELS = {}));
export var SPECIES_TYPE;
(function (SPECIES_TYPE) {
    SPECIES_TYPE["SHARKS"] = "sharks";
    SPECIES_TYPE["RAYS"] = "rays";
    SPECIES_TYPE["CHIMAERAS"] = "chimaeras";
})(SPECIES_TYPE || (SPECIES_TYPE = {}));
export var CONSERVATION_STATUS;
(function (CONSERVATION_STATUS) {
    CONSERVATION_STATUS["EX"] = "Extinct (EX)";
    CONSERVATION_STATUS["EW"] = "Extinct in the Wild (EW)";
    CONSERVATION_STATUS["CR"] = "Critically Endangered (CR)";
    CONSERVATION_STATUS["EN"] = "Endangered (EN)";
    CONSERVATION_STATUS["VU"] = "Vulnerable (VU)";
    CONSERVATION_STATUS["NT"] = "Near Threatened (NT)";
    CONSERVATION_STATUS["CD"] = "Conservation Dependent (CD)";
    CONSERVATION_STATUS["LC"] = "Least Concern (LC)";
    CONSERVATION_STATUS["DD"] = "Data Deficient (DD)";
    CONSERVATION_STATUS["NE"] = "Not Evaluated (NE)";
})(CONSERVATION_STATUS || (CONSERVATION_STATUS = {}));
export var DEPTH_ZONE;
(function (DEPTH_ZONE) {
    DEPTH_ZONE["SHALLOW_WATER"] = "Shallow Water (0-200m)";
    DEPTH_ZONE["MID_WATER"] = "Mid-Water (200-1000m)";
    DEPTH_ZONE["DEEP_WATER"] = "Deep Water (1000-4000m)";
    DEPTH_ZONE["ABYSSAL"] = "Abyssal (4000-6000m)";
    DEPTH_ZONE["HADAL"] = "Hadal (6000m+)";
})(DEPTH_ZONE || (DEPTH_ZONE = {}));
export var REPRODUCTIVE_STRATEGY;
(function (REPRODUCTIVE_STRATEGY) {
    REPRODUCTIVE_STRATEGY["OVIPAROUS"] = "Oviparous";
    REPRODUCTIVE_STRATEGY["VIVIPAROUS"] = "Viviparous";
    REPRODUCTIVE_STRATEGY["OVOVIVIPAROUS"] = "Ovoviviparous";
    REPRODUCTIVE_STRATEGY["EMBRYTROPHY"] = "Embrytrophy";
    REPRODUCTIVE_STRATEGY["PARTHENOGENESIS"] = "Parthenogenesis";
    REPRODUCTIVE_STRATEGY["OOPHAGY"] = "Oophagy";
    REPRODUCTIVE_STRATEGY["EMBRYOPHAGY"] = "Embryophagy";
    REPRODUCTIVE_STRATEGY["UNKNOWN"] = "Unknown";
})(REPRODUCTIVE_STRATEGY || (REPRODUCTIVE_STRATEGY = {}));
export var REEF_ZONE;
(function (REEF_ZONE) {
    REEF_ZONE["TWA"] = "Tropical Western Atlantic (TWA)";
    REEF_ZONE["PAC"] = "California, Pacific Northwest, and Alaska (PAC)";
    REEF_ZONE["HAW"] = "Hawaii (HAW)";
    REEF_ZONE["TEP"] = "Tropical Eastern Pacific (TEP)";
    REEF_ZONE["SOP"] = "South Pacific (SOP)";
    REEF_ZONE["NE"] = "Northeast US and Eastern Canada (NE)";
    REEF_ZONE["SAS"] = "South Atlantic States (SAS)";
    REEF_ZONE["CIP"] = "Central Indo-Pacific (CIP)";
    REEF_ZONE["EAM"] = "Eastern Atlantic and Mediterranean (EAM)";
    REEF_ZONE["IORS"] = "Indian Ocean and Red Sea (IORS)";
})(REEF_ZONE || (REEF_ZONE = {}));
// https://en.m.wikipedia.org/wiki/List_of_feeding_behaviours
export var FEEDING_BEHAVIOR;
(function (FEEDING_BEHAVIOR) {
    FEEDING_BEHAVIOR["CARNIVOROUS"] = "Carnivorous";
    FEEDING_BEHAVIOR["OMNIVOROUS"] = "Omnivorous";
    FEEDING_BEHAVIOR["PLANKTIVOROUS"] = "Planktivorous";
    FEEDING_BEHAVIOR["PISCIVOROUS"] = "Piscivorous";
    FEEDING_BEHAVIOR["MOLLUSCIVOROUS"] = "Molluscivorous";
})(FEEDING_BEHAVIOR || (FEEDING_BEHAVIOR = {}));
export var OCEAN_ZONE;
(function (OCEAN_ZONE) {
    OCEAN_ZONE["EPIPELAGIC"] = "Epipelagic";
    OCEAN_ZONE["MESOPELAGIC"] = "Mesopelagic";
    OCEAN_ZONE["BATHYPELAGIC"] = "Bathypelagic";
    OCEAN_ZONE["ABYSSALPELAGIC"] = "Abyssalpelagic";
    OCEAN_ZONE["HADALPELAGIC"] = "Hadalpelagic";
})(OCEAN_ZONE || (OCEAN_ZONE = {}));
export var TEMPERATURE_REGULATION;
(function (TEMPERATURE_REGULATION) {
    TEMPERATURE_REGULATION["ENDOTHERMIC"] = "Endothermic";
    TEMPERATURE_REGULATION["REGIONALLY_ENDOTHERMIC"] = "Regionally Endothermic";
    TEMPERATURE_REGULATION["ECTOTHERMIC"] = "Ectothermic";
})(TEMPERATURE_REGULATION || (TEMPERATURE_REGULATION = {}));
export var GEOGRAPHICAL_DISTRIBUTION;
(function (GEOGRAPHICAL_DISTRIBUTION) {
    GEOGRAPHICAL_DISTRIBUTION["ENDEMIC"] = "Endemic";
    GEOGRAPHICAL_DISTRIBUTION["COSMOPOLITAN"] = "Cosmopolitan";
    GEOGRAPHICAL_DISTRIBUTION["TROPICAL"] = "Tropical";
    GEOGRAPHICAL_DISTRIBUTION["TEMPERATE"] = "Temperate";
    GEOGRAPHICAL_DISTRIBUTION["POLAR"] = "Polar";
})(GEOGRAPHICAL_DISTRIBUTION || (GEOGRAPHICAL_DISTRIBUTION = {}));
// https://en.wikipedia.org/wiki/Pelagic_zone
// https://en.wikipedia.org/wiki/Oceanic_zone - picture explains this
export var HABITAT;
(function (HABITAT) {
    HABITAT["RIVERS"] = "Rivers";
    HABITAT["LAKES"] = "Lakes";
    HABITAT["ESTUARIES"] = "Estuaries";
    HABITAT["PELAGIC_ZONE"] = "Pelagic Zone";
    HABITAT["NERITIC_ZONE"] = "Neritic Zone";
    HABITAT["OCEANIC_ZONE"] = "Oceanic Zone";
    HABITAT["DEMERSAL_ZONE"] = "Demersal Zone";
    HABITAT["BENTHIC_ZONE"] = "Benthic Zone";
    HABITAT["MANGROVE_FORESTS"] = "Mangrove Forests";
    HABITAT["KELP_FORESTS"] = "Kelp Forests";
    HABITAT["INTERTIDAL_ZONE"] = "Intertidal Zone";
    HABITAT["SEAGRASS_BEDS"] = "Seagrass Beds";
    HABITAT["CORAL_REEFS"] = "Coral Reefs";
    HABITAT["CONTINENTAL_SHELVES"] = "Continental Shelves";
    HABITAT["ISLANDS"] = "Islands";
    HABITAT["LAGOONS"] = "Lagoons";
    HABITAT["SANDY_PLAINS"] = "Sandy Plains";
})(HABITAT || (HABITAT = {}));
export var WATER_COLUMN;
(function (WATER_COLUMN) {
    WATER_COLUMN["SURFACE"] = "Surface";
    WATER_COLUMN["MIDWATER"] = "Midwater";
    WATER_COLUMN["DEEP_WATER"] = "Deep Water";
})(WATER_COLUMN || (WATER_COLUMN = {}));
export var PHYSICAL_CHARACTERISTIC;
(function (PHYSICAL_CHARACTERISTIC) {
    PHYSICAL_CHARACTERISTIC["COUNTERSHADING"] = "Countershading";
    PHYSICAL_CHARACTERISTIC["TORPEDO_SHAPE"] = "Torpedo Shape";
    PHYSICAL_CHARACTERISTIC["WHITE_TIPPED_FIRST_DORSAL_FIN"] = "White-Tipped First Dorsal Fin";
    PHYSICAL_CHARACTERISTIC["WHITE_TIPPED_SECOND_DORSAL_FIN"] = "White-Tipped Second Dorsal Fin";
    PHYSICAL_CHARACTERISTIC["BLACK_TIPPED_FIRST_DORSAL_FIN"] = "Black-Tipped First Dorsal Fin";
    PHYSICAL_CHARACTERISTIC["BLACK_TIPPED_SECOND_DORSAL_FIN"] = "Black-Tipped Second Dorsal Fin";
})(PHYSICAL_CHARACTERISTIC || (PHYSICAL_CHARACTERISTIC = {}));
export var BEHAVIOR;
(function (BEHAVIOR) {
    BEHAVIOR["MIGRATING"] = "Migrating";
    BEHAVIOR["BREACHING"] = "Breaching";
    BEHAVIOR["NONE"] = "No Unique Behaviors";
})(BEHAVIOR || (BEHAVIOR = {}));
export var GROUP_BEHAVIOR;
(function (GROUP_BEHAVIOR) {
    GROUP_BEHAVIOR["SOLITARY"] = "Solitary";
    GROUP_BEHAVIOR["SCHOOLING"] = "Schooling";
})(GROUP_BEHAVIOR || (GROUP_BEHAVIOR = {}));
export var NUM_GILLS;
(function (NUM_GILLS) {
    NUM_GILLS["FOUR"] = "4 Gills";
    NUM_GILLS["FIVE"] = "5 Gills";
    NUM_GILLS["SIX"] = "6 Gills";
    NUM_GILLS["SEVEN"] = "7 Gills";
})(NUM_GILLS || (NUM_GILLS = {}));
export var NUM_DORSAL_FINS;
(function (NUM_DORSAL_FINS) {
    NUM_DORSAL_FINS["ZERO"] = "No Dorsal Fins";
    NUM_DORSAL_FINS["ONE"] = "1 Dorsal Fin";
    NUM_DORSAL_FINS["TWO"] = "2 Dorsal Fins";
})(NUM_DORSAL_FINS || (NUM_DORSAL_FINS = {}));
export var ANAL_FIN;
(function (ANAL_FIN) {
    ANAL_FIN["YES"] = "Yes Anal Fin";
    ANAL_FIN["NO"] = "No Anal Fin";
})(ANAL_FIN || (ANAL_FIN = {}));
export var SPIRACLES;
(function (SPIRACLES) {
    SPIRACLES["YES"] = "Yes Spiracles";
    SPIRACLES["NO"] = "No Spiracles";
})(SPIRACLES || (SPIRACLES = {}));
export var FLATTENED_BODY;
(function (FLATTENED_BODY) {
    FLATTENED_BODY["YES"] = "Yes Flattened Body";
    FLATTENED_BODY["NO"] = "No Flattened Body";
})(FLATTENED_BODY || (FLATTENED_BODY = {}));
export var NICTITATING_MEMBRANE;
(function (NICTITATING_MEMBRANE) {
    NICTITATING_MEMBRANE["YES"] = "Yes Nictitating Membrane";
    NICTITATING_MEMBRANE["NO"] = "No Nictitating Membrane";
})(NICTITATING_MEMBRANE || (NICTITATING_MEMBRANE = {}));
export var PROXIMAL_DORSAL_FINS;
(function (PROXIMAL_DORSAL_FINS) {
    PROXIMAL_DORSAL_FINS["YES"] = "Yes Proximal Dorsal Fins";
    PROXIMAL_DORSAL_FINS["NO"] = "No Proximal Dorsal Fins";
})(PROXIMAL_DORSAL_FINS || (PROXIMAL_DORSAL_FINS = {}));
export var CAUDAL_FIN_SHAPE;
(function (CAUDAL_FIN_SHAPE) {
    CAUDAL_FIN_SHAPE["HETEROCERCAL"] = "Heterocercal";
    CAUDAL_FIN_SHAPE["HOMOCERCAL"] = "Homocercal";
})(CAUDAL_FIN_SHAPE || (CAUDAL_FIN_SHAPE = {}));
export var MOUTH_IN_FRONT_OF_EYES;
(function (MOUTH_IN_FRONT_OF_EYES) {
    MOUTH_IN_FRONT_OF_EYES["MOUTH_IN_FRONT_OF_EYES"] = "Mouth In Front of Eyes";
    MOUTH_IN_FRONT_OF_EYES["MOUTH_NOT_IN_FRONT_OF_EYES"] = "Mouth Not In Front of Eyes";
})(MOUTH_IN_FRONT_OF_EYES || (MOUTH_IN_FRONT_OF_EYES = {}));
export var BIOLUMINESCENT;
(function (BIOLUMINESCENT) {
    BIOLUMINESCENT["YES"] = "Is Bioluminescent";
    BIOLUMINESCENT["NO"] = "Not Bioluminescent";
})(BIOLUMINESCENT || (BIOLUMINESCENT = {}));
export var DORSAL_FIN_SPINES;
(function (DORSAL_FIN_SPINES) {
    DORSAL_FIN_SPINES["YES"] = "Both Dorsal Fin Spines";
    DORSAL_FIN_SPINES["ONLY_ON_FIRST"] = "Only First Dorsal Fin Spine";
    DORSAL_FIN_SPINES["NO"] = "No Dorsal Fin Spines";
})(DORSAL_FIN_SPINES || (DORSAL_FIN_SPINES = {}));
export var TAIL_SPINES;
(function (TAIL_SPINES) {
    TAIL_SPINES["YES"] = "Yes Tail Spines";
    TAIL_SPINES["NO"] = "No Tail Spines";
})(TAIL_SPINES || (TAIL_SPINES = {}));
export var ELECTRIC_ORGAN;
(function (ELECTRIC_ORGAN) {
    ELECTRIC_ORGAN["YES"] = "Yes Electric Organ";
    ELECTRIC_ORGAN["NO"] = "No Electric Organ";
})(ELECTRIC_ORGAN || (ELECTRIC_ORGAN = {}));
export var VENOMOUS_SPINE;
(function (VENOMOUS_SPINE) {
    VENOMOUS_SPINE["YES"] = "Yes Venomous Spine";
    VENOMOUS_SPINE["NO"] = "No Venomous Spine";
})(VENOMOUS_SPINE || (VENOMOUS_SPINE = {}));
export var OPERCULUM;
(function (OPERCULUM) {
    OPERCULUM["YES"] = "Yes Operculum";
    OPERCULUM["NO"] = "No Operculum";
})(OPERCULUM || (OPERCULUM = {}));
export var SNOUT_SHAPE;
(function (SNOUT_SHAPE) {
    SNOUT_SHAPE["ELONGATED"] = "Elongated Snout";
    SNOUT_SHAPE["SHORT"] = "Short Snout";
    SNOUT_SHAPE["PLOUGH_LIKE"] = "Plough-like Snout";
})(SNOUT_SHAPE || (SNOUT_SHAPE = {}));
export function getEnumCategory(tag) {
    if (Object.values(NUM_DORSAL_FINS).includes(tag))
        return "NUM_DORSAL_FINS";
    if (Object.values(NUM_GILLS).includes(tag))
        return "NUM_GILLS";
    if (Object.values(ANAL_FIN).includes(tag))
        return "ANAL_FIN";
    if (Object.values(NICTITATING_MEMBRANE).includes(tag))
        return "NICTITATING_MEMBRANE";
    if (Object.values(CAUDAL_FIN_SHAPE).includes(tag))
        return "CAUDAL_FIN_SHAPE";
    if (Object.values(MOUTH_IN_FRONT_OF_EYES).includes(tag))
        return "MOUTH_IN_FRONT_OF_EYES";
    if (Object.values(BIOLUMINESCENT).includes(tag))
        return "BIOLUMINESCENT";
    if (Object.values(DORSAL_FIN_SPINES).includes(tag))
        return "DORSAL_FIN_SPINES";
    if (Object.values(SPIRACLES).includes(tag))
        return "SPIRACLES";
    if (Object.values(FLATTENED_BODY).includes(tag))
        return "FLATTENED_BODY";
    if (Object.values(PROXIMAL_DORSAL_FINS).includes(tag))
        return "PROXIMAL_DORSAL_FINS";
    if (Object.values(TAIL_SPINES).includes(tag))
        return "TAIL_SPINES";
    if (Object.values(ELECTRIC_ORGAN).includes(tag))
        return "ELECTRIC_ORGAN";
    if (Object.values(VENOMOUS_SPINE).includes(tag))
        return "VENOMOUS_SPINE";
    if (Object.values(OPERCULUM).includes(tag))
        return "OPERCULUM";
    if (Object.values(SNOUT_SHAPE).includes(tag))
        return "SNOUT_SHAPE";
    if (Object.values(CONSERVATION_STATUS).includes(tag))
        return "CONSERVATION_STATUS";
    if (Object.values(TEMPERATURE_REGULATION).includes(tag))
        return "TEMPERATURE_REGULATION";
    if (Object.values(FEEDING_BEHAVIOR).includes(tag))
        return "FEEDING_BEHAVIOR";
    if (Object.values(REPRODUCTIVE_STRATEGY).includes(tag))
        return "REPRODUCTIVE_STRATEGY";
    if (Object.values(GROUP_BEHAVIOR).includes(tag))
        return "GROUP_BEHAVIOR";
    if (Object.values(REEF_ZONE).includes(tag))
        return "REEF_ZONE";
    if (Object.values(OCEAN_ZONE).includes(tag))
        return "OCEAN_ZONE";
    if (Object.values(GEOGRAPHICAL_DISTRIBUTION).includes(tag))
        return "GEOGRAPHICAL_DISTRIBUTION";
    if (Object.values(HABITAT).includes(tag))
        return "HABITAT";
    if (Object.values(WATER_COLUMN).includes(tag))
        return "WATER_COLUMN";
    if (Object.values(DEPTH_ZONE).includes(tag))
        return "depthZone";
    if (Object.values(PHYSICAL_CHARACTERISTIC).includes(tag))
        return "PHYSICAL_CHARACTERISTIC";
    if (Object.values(BEHAVIOR).includes(tag))
        return "BEHAVIOR";
    return undefined;
}
export const DEFAULT_TAGS = {
    [SPECIES_TYPE.SHARKS]: [
        CONSERVATION_STATUS.LC,
        REPRODUCTIVE_STRATEGY.UNKNOWN,
        TEMPERATURE_REGULATION.ECTOTHERMIC,
        FEEDING_BEHAVIOR.CARNIVOROUS,
        GROUP_BEHAVIOR.SOLITARY,
        BEHAVIOR.NONE,
        NUM_DORSAL_FINS.TWO,
        NUM_GILLS.FIVE,
        ANAL_FIN.YES,
        SPIRACLES.YES,
        FLATTENED_BODY.NO,
        NICTITATING_MEMBRANE.NO,
        CAUDAL_FIN_SHAPE.HETEROCERCAL,
        MOUTH_IN_FRONT_OF_EYES.MOUTH_NOT_IN_FRONT_OF_EYES,
        BIOLUMINESCENT.NO,
        DORSAL_FIN_SPINES.NO,
        PROXIMAL_DORSAL_FINS.NO
    ],
    [SPECIES_TYPE.RAYS]: [
        CONSERVATION_STATUS.LC,
        REPRODUCTIVE_STRATEGY.UNKNOWN,
        TEMPERATURE_REGULATION.ECTOTHERMIC,
        FEEDING_BEHAVIOR.CARNIVOROUS,
        GROUP_BEHAVIOR.SOLITARY,
        BEHAVIOR.NONE,
        NUM_GILLS.FIVE,
        NUM_DORSAL_FINS.TWO,
        SPIRACLES.YES,
        FLATTENED_BODY.YES,
        BIOLUMINESCENT.NO,
        TAIL_SPINES.NO,
        ELECTRIC_ORGAN.NO,
        VENOMOUS_SPINE.NO,
    ],
    [SPECIES_TYPE.CHIMAERAS]: [
        CONSERVATION_STATUS.LC,
        REPRODUCTIVE_STRATEGY.UNKNOWN,
        TEMPERATURE_REGULATION.ECTOTHERMIC,
        FEEDING_BEHAVIOR.CARNIVOROUS,
        GROUP_BEHAVIOR.SOLITARY,
        BEHAVIOR.NONE,
        NUM_GILLS.FOUR,
        NUM_DORSAL_FINS.TWO,
        SPIRACLES.NO,
        FLATTENED_BODY.NO,
        BIOLUMINESCENT.NO,
        OPERCULUM.YES,
        SNOUT_SHAPE.SHORT,
    ]
};
//------------------------------------------------------------------------------------------------------------------
export var GEOCHRONOLOGIC_UNIT;
(function (GEOCHRONOLOGIC_UNIT) {
    GEOCHRONOLOGIC_UNIT["EON"] = "Eon";
    GEOCHRONOLOGIC_UNIT["ERA"] = "Era";
    GEOCHRONOLOGIC_UNIT["PERIOD"] = "Period";
    GEOCHRONOLOGIC_UNIT["SUBPERIOD"] = "Subperiod";
    GEOCHRONOLOGIC_UNIT["EPOCH"] = "Epoch";
    GEOCHRONOLOGIC_UNIT["SUBEPOCH"] = "Subepoch";
    GEOCHRONOLOGIC_UNIT["AGE"] = "Age";
})(GEOCHRONOLOGIC_UNIT || (GEOCHRONOLOGIC_UNIT = {}));
